import { Tooltip } from '@material-ui/core';
import { Badge } from 'components/bgp-overview/Badge';
import React from 'react';
import { useQueries, UseQueryResult } from 'react-query';
import { getAsName } from 'ripe/asName';
import { ASN } from 'ripe/common';
import { BoxPanel } from '../BoxPanel';
import { Divider } from '../Divider';

interface UpstreamsRowProps {
  upstreamAsns: ASN[];
}

export const UpstreamsRow: React.FC<UpstreamsRowProps> = ({ upstreamAsns }) => {
  const nameResults = useQueries(
    upstreamAsns.map((asn) => {
      return {
        queryKey: ['as-name', asn],
        queryFn: () => getAsName(asn),
      };
    }),
  ) as UseQueryResult<string>[];

  if (0 === upstreamAsns.length) {
    return null;
  }

  return (
    <div className="h-full flex-grow">
      <div className="font-bold my-3">
        <h1 className="truncate">Route visibility by upstream</h1>
      </div>

      <BoxPanel className="h-full max-w-max justify-around">
        {upstreamAsns.map((asn, index) => {
          const name = nameResults[index].data ?? '...';
          return (
            <div key={index} className="flex flex-row items-center w-40 h-20">
              {0 === index && <Badge badgeColor="upstream" />}
              {0 !== index && <Divider />}
              <div className="flex flex-row p-4 w-full items-center text-left flex-wrap">
                <span className="w-full">AS {asn}</span>
                <Tooltip title={name}>
                  <span className="overflow-ellipsis whitespace-nowrap overflow-hidden">{name}</span>
                </Tooltip>
              </div>
            </div>
          );
        })}
      </BoxPanel>
    </div>
  );
};
